document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector(".custom-sort__trigger");
  const menu = document.querySelector(".custom-sort__menu");

  if (!trigger || !menu) return;

  trigger.addEventListener("click", () => {
    menu.style.display = menu.style.display === "block" ? "none" : "block";
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".custom-sort")) {
      menu.style.display = "none";
    }
  });
});